// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DailyReportsController from "./daily_reports_controller.js"
application.register("daily-reports", DailyReportsController)

import FiltersController from "./filters_controller.js"
application.register("filters", FiltersController)

import MultiUploadController from "./multi_upload_controller.js"
application.register("multi-upload", MultiUploadController)

import NestedFormController from "./nested_form_controller.js"
application.register("nested-form", NestedFormController)

import ResetFormController from "./reset_form_controller.js"
application.register("reset-form", ResetFormController)

import ScrollController from "./scroll_controller.js"
application.register("scroll", ScrollController)

import SearchController from "./search_controller.js"
application.register("search", SearchController)

import SearchResultsController from "./search_results_controller.js"
application.register("search-results", SearchResultsController)

import Select2Controller from "./select2_controller.js"
application.register("select2", Select2Controller)

import SubsidiaryController from "./subsidiary_controller.js"
application.register("subsidiary", SubsidiaryController)
